<template>
	<div>
		<!-- <figure class="h-10 w-10 m-auto md:h-16 md:w-16 border-secondary-300 rtl:border-l ltr:border-r">
			<img class="object-contain h-full w-full" data-src="/front/img/dummy_data/2.jpeg">
		</figure> -->
		<div v-if="orders.length  != 0" v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="1" >
			<div v-for="order in orders" class="table-container border rounded-lg p-1 md:p-4 mt-4" v-lazy-container="{ selector: 'img' }">
				<table class="w-full overflow-x-auto">
					<thead class="rtl:text-right ltr:text-left">
						<template v-if="windowWidth > 520">
							<tr>
								<th class="text-black font-semibold  pb-8 text-xs md:text-sm p-3 md:p-0">رقم الفاتورة :
								{{ order.id }}</th>
								<th class="text-black font-semibold  pb-8 text-xs md:text-sm p-3 md:p-0">تاريخ الطلب :
								{{ order.created_at }}</th>
								<th class="text-black font-semibold  pb-8 text-xs md:text-sm p-3 md:p-0">{{ order.payment_method }} - {{ order.paid_status }}</th>
								<th class="text-secondary-300 font-semibold  pb-8 text-xs md:text-sm p-3 md:p-0">{{ order.status }}</th>
							</tr>
						</template>
						<template v-else>
							<tr class="bg-gray-200">
								<th colspan="2" class="text-black font-semibold  text-xs md:text-sm p-1 md:p-0 rounded-tr">رقم الفاتورة : <br/>
								{{ order.id }}</th>
								<th colspan="2" class="text-black font-semibold  text-xs md:text-sm p-1 md:p-0 rounded-tl">تاريخ الطلب : <br/>
								{{ order.created_at }}</th>								
							</tr>
							<tr class="bg-gray-200">
								<th colspan="2" class="text-black font-semibold  text-xs md:text-sm p-1 md:p-0 rounded-br">{{ order.payment_method }}<br/>{{ order.paid_status }}</th>
								<th colspan="2" class="text-secondary-300 font-semibold  text-xs md:text-sm p-1 md:p-0 rounded-bl">{{ order.status }}</th>
							</tr>
						</template>
					</thead>
					<tbody>
						<tr v-for="item in order.items">
							<td v-if="windowWidth > 520" class="border-b pb-4 p-3">
								<figure class="h-10 w-10 m-auto md:h-16 md:w-16 border-secondary-300 rtl:border-l ltr:border-r">
									<img class="object-contain h-full w-full" :data-src="item.image">
								</figure>
							</td>
							<template v-if="windowWidth > 520">
								<td colspan="2" valign="center" class="border-b pb-4 p-3">
									<a :href="item.product_route" class="text-secondary-300 font-bold text-xs md:text-sm">
										{{ item.product_name }}
									</a>
								</td>
							</template>
							<template v-else>
								<td colspan="3" valign="center" class="border-b pb-4 p-3">
									<a :href="item.product_route" class="text-secondary-300 font-bold text-xs md:text-sm">
										{{ item.product_name }}
									</a>
								</td>
							</template>
							<td valign="center" class="text-secondary-300 font-semibold text-xs md:text-sm border-b pb-4 p-3">
								<span>	{{ item.total }} ريال</span>
							</td>
						</tr>
						<tr>
							
							<template v-if="windowWidth > 520">
								<td colspan="2"></td>
								<td class="py-3 px-2 md:px-0">
									<p class="text-gray-500 font-bold text-xs md:text-sm mb-2">	
										مصاريف الشحن
									</p>
									<p class="text-gray-500 font-bold text-xs md:text-sm">
										الاجمالي
									</p>
								</td>
							</template>
							<template v-else>
								<td colspan="2" class="py-3 px-2 md:px-0">
									<p class="text-gray-500 font-bold text-xs md:text-sm mb-2">	
										مصاريف الشحن
									</p>
									<p class="text-gray-500 font-bold text-xs md:text-sm">
										الاجمالي
									</p>
								</td>
							</template>
							<td colspan="2" class="py-3 px-2 md:px-0">
								<p class="text-secondary-300 font-bold text-xs md:text-sm mb-2">
									{{ order.shipping }} ريال
								</p>
								<p class="text-secondary-300 font-bold text-xs md:text-sm">
									{{ order.total }} ريال
								</p>
							</td>
						</tr>
					</tbody>
				</table>
        <div v-if="!order.order_paid && order.status_id == 1" class="add-rate-orders left-order-btns">

          <a  :href="`/payment_retry/${order.id}`" v-if="!order.order_paid && order.status_id == 1" class="button mt-8 bg-secondary-200 hover:bg-primary text-white repay-btn">
            <span >اعادة الدفع</span>
          </a>
        </div>
				<collapse class="order-collapse" accordion is-fullwidth>
					<collapse-item title="تفاصيل الطلب">
						<div class="border rounded-lg">
							<h3 class="bg-primary rounded-lg px-3 py-2 text-white border">تفاصيل الفاتورة</h3>
							<div class="table-container p-4 text-center">
								<table class="w-full overflow-x-auto">
									<thead>
										<tr>
											<th class="text-secondary-300 font-semibold text-xs md:text-sm pb-8 rtl:text-right ltr:text-left md:rtl:text-center md:ltr:text-center p-3">اسم المنتج</th>
											<th class="text-secondary-300 font-semibold text-xs md:text-sm pb-8 rtl:text-right ltr:text-left md:rtl:text-center md:ltr:text-center p-3 md:p-0">السعر</th>
											<th class="text-secondary-300 font-semibold text-xs md:text-sm pb-8 rtl:text-right ltr:text-left md:rtl:text-center md:ltr:text-center p-3 md:p-0">اللون</th>
                      <th class="text-secondary-300 font-semibold text-xs md:text-sm pb-8 rtl:text-right ltr:text-left md:rtl:text-center md:ltr:text-center p-3 md:p-0">المقاس</th>
											<th class="text-secondary-300 font-semibold text-xs md:text-sm pb-8 rtl:text-right ltr:text-left md:rtl:text-center md:ltr:text-center p-3 md:p-0">العدد</th>
											<th class="text-secondary-300 font-semibold text-xs md:text-sm pb-8 rtl:text-right ltr:text-left md:rtl:text-center md:ltr:text-center p-3 md:p-0">الإجمالى</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in order.items">
											<td valign="center" class="border-b pb-4">
												<a :href="item.product_route" class="text-gray-500 font-bold text-xs md:text-sm">
													{{ item.product_name }}
												</a>
											</td>
											<td valign="center" class="border-b pb-4">
												<span class="text-gray-500 font-bold text-xs md:text-sm">
													{{ item.product_price }} ريال
												</span>
											</td>
											<td valign="center" class="border-b pb-4">
												<span class="text-gray-500 font-bold text-xs md:text-sm">
													{{ item.product_color }}
												</span>
											</td>
                      <td valign="center" class="border-b pb-4">
												<span class="text-gray-500 font-bold text-xs md:text-sm">
													{{ item.product_size }}
												</span>
                      </td>
											<td valign="center" class="border-b pb-4">
												<span class="text-gray-500 font-bold text-xs md:text-sm">
													{{ item.quantity }}
												</span>
											</td>
											<td valign="center" class="border-b pb-4">
												<span class="text-gray-500 font-bold text-xs md:text-sm">
													{{ item.total }} ريال
												</span>
											</td>
										</tr>
										<tr>
											
											<template v-if="windowWidth > 520">
												<td colspan="4" class="border-b"></td>
												<td class="py-3 border-b">
													<p class="text-gray-500 font-bold text-xs md:text-sm mb-2">	
														مصاريف الشحن
													</p>
												</td>
												<td class="py-3 border-b">
													<p class="text-gray-500 font-bold text-xs md:text-sm mb-2">
														{{ order.shipping }} ريال
													</p>
												</td>
											</template>
											<template v-else>
												<td colspan="3" class="py-3 border-b">
													<p class="text-gray-500 font-bold text-xs md:text-sm mb-2">	
														مصاريف الشحن
													</p>
												</td>
												<td colspan="3" class="py-3 border-b">
													<p class="text-gray-500 font-bold text-xs md:text-sm mb-2">
														{{ order.shipping }} ريال
													</p>
												</td>
											</template>
										</tr>
										<tr>
											
											<template v-if="windowWidth > 520">
												<td colspan="4"></td>
												<td class="py-3">
													<p class="text-secondary-300 font-bold text-xs md:text-sm mb-2">	
														الإجمالى
													</p>
												</td>
												<td class="py-3">
													<p class="text-secondary-300 font-bold text-xs md:text-sm mb-2">
														{{ order.total }} ريال
													</p>
												</td>
											</template>
											<template v-else>
												<td colspan="3" class="py-3">
													<p class="text-secondary-300 font-bold text-xs md:text-sm mb-2">	
														الإجمالى
													</p>
												</td>
												<td colspan="3" class="py-3">
													<p class="text-secondary-300 font-bold text-xs md:text-sm mb-2">
														{{ order.total }} ريال
													</p>
												</td>
											</template>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="border rounded-lg px-4 py-8 mt-4">
							<h3 class="text-center font-bold text-primary mb-8 text-xs md:text-base">طريقه الدفع وعنوان الشحن</h3>
							<div class="flex flex-wrap text-xs md:text-base">
								<div class="w-full md:w-1/2 font-bold">
									<label class="label text-secondary-300">طريقة الدفع  : </label>
									<span class="text-primary">{{ order.payment_method }}</span>
								</div>
								<div class="w-full md:w-1/2 font-bold">
									<label class="label text-secondary-300">العنوان : </label>
									<span class="text-primary">{{ order.address }}</span>
								</div>
							</div>
						</div>
					</collapse-item>
				</collapse>
			</div>
			<div class="w-full text-center mt-4" v-show="loadMore">
				<div class="position-relative inline-block w-full">
					<img data-src="/front/img/illustrations/loader.svg" alt="" class="height-20 w-20" />
				</div>
			</div>
		</div>
		<div v-else>
			<figure class="w-full">
				<img src="/front/img/illustrations/no_orders.svg">
			</figure>
			<p class="text-center text-primary font-semibold">لا يوجد مشتريات</p>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	import AddRate from "./AddRate";
	export default {
		name: 'Orders',
		components:{
			AddRate
		},
		directives: {
			infiniteScroll
		},
		props: {
			url: String,
			sitelocale: String,
			user_id: {
				type: Number,
				required: true
			}
		},
		computed: {
			busy() {
				return this.fetching
			}
		},
		mounted() {
		},
		data: () => ({
			currentPage: 0,
			fetching: false,
			orders: [],
			nextUrl : String,
			loadMore : true
		}),
		methods: {
			loadNextPage() {
				this.currentPage++;
				this.fetching = true;
				if(this.nextUrl != null){
					axios.get(this.nextUrl).then(({ data }) => {
						this.orders.push(...data.data);
						this.nextUrl = data.links.next;
						this.fetching = false;
					});
				}
				else{
					this.loadMore = false;
				}
			},
			deleteOrder(order) {
				axios.delete(`/orders/${order}`).then(({data}) => {
					let toaster = this.$toasted;
					toaster.success(data.message);
					setTimeout(()=>{
						location.reload();
					}, 1500);
				});
			},
		},
		created() {
			this.nextUrl = this.url;
			this.loadNextPage();
		}
	};
</script>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// resources/assets/js/front/components/Orders.vue